import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, Team, Pricing, Clients, Features, Compositions, Products } from '../../sections';



const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <Features /> {/* Features Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Products /> {/* Featured Products */}
      <Compositions /> {/* Water Compositions section */}
      <Pricing /> {/* Pricing section */}
      <Team /> {/* Team section */}
      <Testimonials /> {/* Testimonials Slider */}
      <Blogs /> {/* Latest blog posts */}
      <Clients /> {/* Clients Slider */}
    </div>
  )

}

export default HomePage;